import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

import { Logger } from '@core';
import { CredentialsService } from './credentials.service';
import { LOGIN, URL_REQUESTS_UPDATE_DOCUMENTATION } from '../constants/routes.constants';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationservice: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.credentialsService.isAuthenticated() && state.url === LOGIN) {
      this.router.navigate(['/home'], { replaceUrl: true });
      return false;
    } else if (
      !this.credentialsService.isAuthenticated() &&
      state.url.includes(URL_REQUESTS_UPDATE_DOCUMENTATION) &&
      state.url.includes('url=true')
    ) {
      this.router.navigate(['/login'], {
        queryParams: { updateDocumentationURL: true, numSol: state.url?.split('/')[3]?.split('?')[0] },
      });
      return false;
    } else if (
      this.credentialsService.isAuthenticated() && this.credentialsService.credentials
        ? this.credentialsService.credentials.changePassword === false
        : ''
    ) {
      if (state.url === '/password') {
        this.router.navigate(['/home'], { replaceUrl: true });
        return false;
      }
      return true;
    } else if (
      this.credentialsService.isAuthenticated() &&
      this.credentialsService.credentials.changePassword === true
    ) {
      if (state.url === '/password') {
        return true;
      } else {
        this.credentialsService.setCredentials();
        this.authenticationservice.logout();
        this.router.navigate([LOGIN], { replaceUrl: true });
        return false;
      }
    }

    if (
      state.url !== LOGIN &&
      !state.url.includes('updateDocumentationURL=true') &&
      !this.credentialsService.isAuthenticated() &&
      !(
        state.url.includes('/logalty-signature-async') ||
        state.url.includes('/logalty-signature-thirdParty') ||
        state.url.includes('/comprobacionPing') ||
        state.url.includes('/landing-videoselfing') ||
        state.url.includes('/cookies-policy')
      )
    ) {
      log.debug('Noooot authenticated, redirecting and adding redirect url...' + state.url);
      this.credentialsService.setCredentials();
      this.authenticationservice.logout();
      this.router.navigate([LOGIN], { replaceUrl: true });
      return false;
    } else {
      return true;
    }
  }
}
